<div
  class="panel rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
></div>
<div
  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading hide-for-medium-up"
></div>
<div
  class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
></div>
<div class="rs-me"></div>
<div class="rs-flex-row rs-xpandgrid">
  <div class="rs-flex-columns small-12 medium-4">
    <div class="panel rs-box-shadow">
      <div class="row">
        <div class="columns small-9 small-push-3">
          <div
            class="panel rs-wd-s9 rs-wd-m12 rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-row">
        <div class="rs-flex-columns small-3">
          <div
            class="panel rs-wd-s6 rs-h-s3 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
          ></div>
        </div>
        <div class="rs-flex-columns small-9">
          <div
            class="panel rs-wd-s15 rs-wd-m20 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-skeleton rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s10 rs-wd-m12 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s6 rs-wd-m7 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-skeleton rs-anim-loading"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="rs-me"></div>
